import React from 'react'
import { Button } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

export default function SubmitButton(props) {
  const { t } = useTranslation()
  const { children = t('common-ui:save.action', 'Save'), disabled, isSubmitting, ...rest } = props

  return (
    <Button
      type="submit"
      emphasis="high"
      id="submit-button"
      disabled={disabled || isSubmitting}
      Icon={isSubmitting ? NoticeLoading : undefined}
      iconAtEnd
      {...rest}
    >
      {children}
    </Button>
  )
}
